import type { SubscribeRequest } from "@/modules/events/types/eventDetailsApi"

import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

const EVENT_DETAILS_PATH = "/events/"
const SUBSCRIBE_ENDPOINT = "/subscribe.json"
export const postSubscribe = async (params: SubscribeRequest): Promise<void> => {
  const { locale, hostname, id, authenticityToken, formData } = params

  const path = `/${locale}${EVENT_DETAILS_PATH}${id}${SUBSCRIBE_ENDPOINT}`

  return fetcher(path, {
    hostname,
    requestInit: {
      body: formData,
      headers: {
        "X-CSRF-TOKEN": authenticityToken,
      },
      method: "POST",
    },
    serviceDomain: "MONOLITH_API",
    withDefaultContentType: false,
  })
    .then(handleResponseNotOk)
    .catch(handleFetchError(path))
}
